import { Routes, Route, Navigate, useParams } from "react-router-dom";
import NotFoundPage from "../shared/404";
import Dashboard from "./Dashboard";
import AdminDashboard from "./AdminDashboard";
import BackendLayout from "./BackendLayout";
import Callbacks from "./Callbacks";
import YoutubeCallback from "./YoutubeCallback";
import TiktokCallback from "./TiktokCallback";
import LinkedinCallback from "./LinkedinCallback";
import MetaCallback from "./MetaCallback";
import LoggingIn from "./LogingIn";
import Timeline from "./Timeline";
import CalendarWrapper from "./components/CalendarWrapper";
import OutreachRouter from "./components/Outreach/OutReachRouter";
import AccountabilityRouter from "./components/Accountability/AccountabilityRouter";
import IdeasRouter from "./components/Ideas/IdeasRouter";
import ContentPillarsRouter from "./components/ContentPillars/ContentPillarsRouter";
import SettingsContext from "@serie3/common/auth/SettingsContext";
import { useState, useEffect } from "react";
import fetchSettings from "@serie3/common/Domain/fetchSettings";
import Files from "./Files";
import GroupsRouter from "./components/Groups/GroupsRouter";
import crudApi from "@serie3/common/api/crudApi";
import GroupConfig from "@serie3/common/Modules/Groups/Resources/Endpoints";
import InvitationsRouter from "./components/Invitations/InvitationsRouter";
import TmpPaymentTest from "./Plans";
import Subscriptions from "./components/Settings/Subscriptions";
import Account from "./components/Settings/Account";
import DeleteAccountPage from "./components/Settings/DeleteAccountPage";
import TimelineKanban from "./TimelineKanban";
import Recycler from "./Recycler";
import AdminPage from "./components/Admin/AdminPage";
import ApprovalsInbox from "./components/Approvals/ApprovalsInbox";

// Old /jobs/:jobKey deep links (e.g. from Telegram) land on the admin Jobs tab.
const LegacyJobRedirect = () => {
  const { jobKey } = useParams();
  return <Navigate to={`/admin/jobs/${jobKey}`} replace />;
};

const BackendRouter = ({ currentLanguage, setCurrentLanguage }) => {
  const [settings, setSettings] = useState(null);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const getGroups = async () => {
      let response = await crudApi.justGet(GroupConfig.endpoints.list);
      if (response.ok) {
        setGroups(response.data);
      }
    };

    getGroups();

    const loadStripe = () => {
      const script = document.createElement("script");

      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;

      document.body.appendChild(script);
    };

    loadStripe();
  }, []);

  useEffect(() => {
    fetchSettings(setSettings);
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      <Routes>
        <Route
          element={
            <BackendLayout
              currentLanguage={currentLanguage}
              setCurrentLanguage={setCurrentLanguage}
              groups={groups}
              setGroups={setGroups}
            />
          }
        >
          <Route path="/plans" element={<TmpPaymentTest />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/callbacks/linkedin" element={<LinkedinCallback />} />
          <Route path="/callbacks/youtube" element={<YoutubeCallback />} />
          <Route path="/callbacks/meta" element={<MetaCallback />} />
          <Route path="/callbacks/tiktok" element={<TiktokCallback />} />
          <Route path="/callbacks/*" element={<Callbacks />} />
          <Route path="/login" element={<LoggingIn />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admindashboard" element={<AdminDashboard />} />
          <Route path="/timeline" element={<TimelineKanban />} />
          <Route path="/tabtimeline" element={<Timeline />} />
          <Route path="/calendar" element={<CalendarWrapper />} />
          <Route path="/approvals" element={<ApprovalsInbox />} />
          <Route path="/files" element={<Files />} />
          <Route path="/recycler" element={<Recycler />} />
          <Route path="/admin" element={<Navigate to="/admin/users" replace />} />
          <Route path="/admin/:tab" element={<AdminPage />} />
          <Route path="/admin/jobs/:jobKey" element={<AdminPage />} />
          <Route path="/jobs" element={<Navigate to="/admin/jobs" replace />} />
          <Route path="/jobs/:jobKey" element={<LegacyJobRedirect />} />
          <Route path="/outreach/*" element={<OutreachRouter />} />
          <Route path="/settings/*" element={<Subscriptions />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/delete" element={<DeleteAccountPage />} />
          <Route path="/accountability/*" element={<AccountabilityRouter />} />
          <Route path="/ideas/*" element={<IdeasRouter />} />
          <Route path="/pillars/*" element={<ContentPillarsRouter />} />
          <Route
            path="/groups/*"
            element={<GroupsRouter groups={groups} setGroups={setGroups} />}
          />
          <Route path="/invitations/*" element={<InvitationsRouter />} />
          <Route path="/*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </SettingsContext.Provider>
  );
};

export default BackendRouter;
